import Button from '@ui/atoms/design-system/Button';
import { buttonSizes } from '@ui/atoms/utils/enums';
import texts from '@components/Homepage/en.json';
import useWindowDimensions from '@hooks/useWindowDimensions';
import { useMemo } from 'react';

const ExploreOpportunitiesButton = ({
    onButtonClick,
    className,
    ctaButtonText = '',
    gtmTag = '',
    buttonSize = ''
}) => {
    const { width } = useWindowDimensions();
    const isMobile = useMemo(() => width < 768, [width]);
    return (
        <Button
            buttonSize={buttonSize || buttonSizes.LARGE}
            buttonText={
                ctaButtonText ? ctaButtonText : texts?.ExploreOpportunities
            }
            onClick={() => {
                onButtonClick();
            }}
            className={`!rounded-full ${className}`}
            gtmTag={gtmTag}
        />
    );
};

export default ExploreOpportunitiesButton;